import React from 'react';

import { types_places } from '../adminDOU/components/Statistica/StatisticaGroups/constants/groupsConstants'

const FiltersSection = ({ tab, filters, onFilterChange, onApplyFilters }) => {
  const renderApplicationsFilters = () => (
    <>
      <div className="row g-3">
        <div className="col-md">
          <label className="publicstatistic-filter-label">Навчальний рік</label>
          <select 
            className="form-select publicstatistic-form-select"
            value={filters.year}
            onChange={(e) => onFilterChange(tab, 'year', e.target.value)}
          >
            <option>2025 → 2026</option>
            <option>2024 → 2025</option>
            <option>2023 → 2024</option>
          </select>
        </div>
        <div className="col-md">
          <label className="publicstatistic-filter-label">Реєстрація в Києві</label>
          <select 
            className="form-select publicstatistic-form-select"
            value={filters.registration}
            onChange={(e) => onFilterChange(tab, 'registration', e.target.value)}
          >
            <option>З підтвердженою реєстрац</option>
            <option>Всі заявки</option>
          </select>
        </div>
        <div className="col-md">
          <label className="publicstatistic-filter-label">Муніципальна картка</label>
          <select 
            className="form-select publicstatistic-form-select"
            value={filters.municipalCard}
            onChange={(e) => onFilterChange(tab, 'municipalCard', e.target.value)}
          >
            <option>Всі заявки</option>
            <option>З муніципальною карткою</option>
          </select>
        </div>
        <div className="col-md">
          <label className="publicstatistic-filter-label">Перебування</label>
          <select 
            className="form-select publicstatistic-form-select"
            value={filters.stayType}
            onChange={(e) => onFilterChange(tab, 'stayType', e.target.value)}
          >
            <option>Всі заявки</option>
            <option>Денне перебування</option>
            <option>Короткочасове перебування</option>
          </select>
        </div>
      </div>
      <div className="row g-3 mt-2">
        <div className="col-md">
          <label className="publicstatistic-filter-label">Пільга</label>
          <select 
            className="form-select publicstatistic-form-select"
            value={filters.benefit}
            onChange={(e) => onFilterChange(tab, 'benefit', e.target.value)}
          >
            <option>Всі заявки</option>
            <option>З пільгами</option>
          </select>
        </div>
        <div className="col-md">
          <label className="publicstatistic-filter-label">Створені</label>
          <select 
            className="form-select publicstatistic-form-select"
            value={filters.created}
            onChange={(e) => onFilterChange(tab, 'created', e.target.value)}
          >
            <option>Всі заявки</option>
            <option>Створені сьогодні</option>
          </select>
        </div>
        <div className="col-md">
          <label className="publicstatistic-filter-label">Запрошення</label>
          <select 
            className="form-select publicstatistic-form-select"
            value={filters.invitations}
            onChange={(e) => onFilterChange(tab, 'invitations', e.target.value)}
          >
            <option>Всі заявки</option>
            <option>З запрошеннями</option>
          </select>
        </div>
        <div className="col-md">
          <label className="publicstatistic-filter-label">Оформлені до садочка</label>
          <select 
            className="form-select publicstatistic-form-select"
            value={filters.enrolled}
            onChange={(e) => onFilterChange(tab, 'enrolled', e.target.value)}
          >
            <option>Всі заявки</option>
            <option>Оформлені</option>
          </select>
        </div>
      </div>
    </>
  );

  const renderGroupsFilters = () => (
    <div className="row g-3">
      <div className="col">
        <label className="publicstatistic-filter-label">Навчальний рік</label>
        <select 
          className="form-select publicstatistic-form-select"
          value={filters.year}
          onChange={(e) => onFilterChange(tab, 'year', e.target.value)}
        >
          <option>2025 → 2026</option>
          <option>2024 → 2025</option>
          <option>2023 → 2024</option>
        </select>
      </div>
      <div className="col">
        <label className="publicstatistic-filter-label">Район</label>
        <select 
          className="form-select publicstatistic-form-select"
          value={filters.district}
          onChange={(e) => onFilterChange(tab, 'district', e.target.value)}
        >
          <option>Голосіївський</option>
          <option>Всі райони</option>
          <option>Печерський</option>
          <option>Шевченківський</option>
          <option>Солом'янський</option>
          <option>Оболонський</option>
        </select>
      </div>
      <div className="col">
        <label className="publicstatistic-filter-label">Вікова категорія</label>
        <select 
          className="form-select publicstatistic-form-select"
          value={filters.ageCategory}
          onChange={(e) => onFilterChange(tab, 'ageCategory', e.target.value)}
        >
          <option>Різновікова — від 3-х років</option>
          <option>Всі категорії</option>
          <option>1-2 роки</option>
          <option>2-3 роки</option>
          <option>3-4 роки</option>
          <option>4-5 років</option>
          <option>5-6 років</option>
          <option>6-7 років</option>
        </select>
      </div>
      <div className="col">
        <label className="publicstatistic-filter-label">Тип місць в групі</label>
        <select 
          className="form-select publicstatistic-form-select"
          value={filters.placeType}
          onChange={(e) => onFilterChange(tab, 'placeType', e.target.value)}
        >
           { types_places.map(t=><option value={t.value}>{t.name}</option>)}
        </select>
      </div>
      <div className="col">
        <label className="publicstatistic-filter-label">Кількість дітей в групі</label>
        <select 
          className="form-select publicstatistic-form-select"
          value={filters.childrenCount}
          onChange={(e) => onFilterChange(tab, 'childrenCount', e.target.value)}
        >
          <option>Від 5 до 20</option>
          <option>Всі групи</option>
          <option>До 10</option>
          <option>10-15</option>
          <option>15-20</option>
          <option>20+</option>
        </select>
      </div>
    </div>
  );

  const renderChildrenFilters = () => (
    <div className="row g-3">
      <div className="col">
        <label className="publicstatistic-filter-label">Навчальний рік</label>
        <select 
          className="form-select publicstatistic-form-select"
          value={filters.year}
          onChange={(e) => onFilterChange(tab, 'year', e.target.value)}
        >
          <option>2025 → 2026</option>
          <option>2024 → 2025</option>
          <option>2023 → 2024</option>
        </select>
      </div>
      <div className="col">
        <label className="publicstatistic-filter-label">Реєстрація в Києві</label>
        <select 
          className="form-select publicstatistic-form-select"
          value={filters.registration}
          onChange={(e) => onFilterChange(tab, 'registration', e.target.value)}
        >
          <option>З підтвердженою реєстрац</option>
          <option>Всі заявки</option>
          <option>Без реєстрації</option>
        </select>
      </div>
      <div className="col">
        <label className="publicstatistic-filter-label">Тип місць</label>
        <select 
          className="form-select publicstatistic-form-select"
          value={filters.placeType}
          onChange={(e) => onFilterChange(tab, 'placeType', e.target.value)}
        >
          { types_places.map(t=><option value={t.value}>{t.name}</option>)}
        </select>
      </div>
      <div className="col">
        <label className="publicstatistic-filter-label">Спеціалізація</label>
        <select 
          className="form-select publicstatistic-form-select"
          value={filters.specialization}
          onChange={(e) => onFilterChange(tab, 'specialization', e.target.value)}
        >
          <option>Будь-яка</option>
          <option>Загальний розвиток</option>
          <option>Спеціальні потреби</option>
        </select>
      </div>
      <div className="col">
        <label className="publicstatistic-filter-label">Станом на</label>
        <select 
          className="form-select publicstatistic-form-select"
          value={filters.asOf}
          onChange={(e) => onFilterChange(tab, 'asOf', e.target.value)}
        >
          <option>Травень</option>
          <option>Квітень</option>
          <option>Березень</option>
          <option>Лютий</option>
          <option>Січень</option>
        </select>
      </div>
    </div>
  );

  const renderFilters = () => {
    switch (tab) {
      case 'applications':
      case 'enrollment':
        return renderApplicationsFilters();
      case 'groups':
        return renderGroupsFilters();
      case 'children':
        return renderChildrenFilters();
      default:
        return null;
    }
  };

  return (
    <div className="publicstatistic-filters-section">
      {renderFilters()}
      <div className="mt-3">
        <button 
          className="btn btn-primary publicstatistic-btn publicstatistic-btn-primary"
          onClick={() => onApplyFilters(tab)}
        >
          Відобразити
        </button>
      </div>
    </div>
  );
};

export default FiltersSection;